import TabelaDownload from "../Download/TabelaDownload/TabelaDownload";
import CardDownload from "../Download/CardDownload/CardDownload";
import CardVerticalDownload from "../Download/CardVerticalDownload/CardVerticalDownload";

export default {
  components: {
    TabelaDownload,
    CardDownload,
    CardVerticalDownload
  },
  props: {
    objetoFiltro: {
      type: Object
    }
  }
};
